export default {
    state: {
        currencies: [],
        currency: {},
        currencyCode: 'BRL'
    },
    actions: {

        INDEX_CURRENCIES({commit}, payload) {
            return window.axios
                .get('/api/public/currencies/list')
                .then(res => {
                    commit('SET_CURRENCIES', res.data.data);
                    return res
                })
                .catch(err => console.log('INDEX_CURRENCIES', err));
        },

        GET_SESSION_CURRENCY({commit}, payload) {

            return window.axios
                .get('/api/public/currencies/get')
                .then(res => {
                    if(res.data.currency)
                        commit('SET_CURRENCY', res.data.currency)
                    return res;
                })
                .catch(err => console.log('GET_SESSION_CURRENCY', err));
        },

        CHANGE_CURRENCY({commit}, payload) {

            const { code } = payload;

            return window.axios
                .put(`/api/public/currencies/update/${code}`)
                .then(res => {
                    if(res.data.currency)
                        commit('SET_CURRENCY', res.data.currency)
                    return res
                })    
                .catch(err => console.log('CHANGE_CURRENCY', err))
        },
    },
    mutations: {
        SET_DEFAULT_CURRENCY(state, payload) {
            state.default = {
                ...payload,
                prefix : payload.currency.prefix ? payload.currency.prefix : '',
                suffix : payload.currency.suffix ? payload.currency.suffix : '',
            };
        },

        SET_CURRENCIES(state, payload) {
            state.currencies = payload;
        },
        SET_CURRENCY(state, payload) {
            state.currency = payload;
            state.currencyCode = payload.code
        }
    },
    getters: {
        CURRENCIES(state) {
            return state.currencies;
        },
        CURRENCY(state) {
            return state.currency;
        },
        DEFAULT_CURRENCY(state) {
            return state.default
        }
    }
}
            